import React, { createContext, useContext, useState, useEffect } from "react";

const AppConfigContext = createContext({ appName: "DocIntel", logoB64: null });

export function useAppConfig() {
  return useContext(AppConfigContext);
}

export function AppConfigProvider({ children }) {
  const [appName, setAppName] = useState("DocIntel");
  const [logoB64, setLogoB64] = useState(null);

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    fetch(`${API}/api/config/public`)
      .then(r => r.json())
      .then(d => {
        if (d.app_name) setAppName(d.app_name);
        if (d.app_logo_base64) setLogoB64(d.app_logo_base64);
      })
      .catch(() => {});
  }, []);

  return (
    <AppConfigContext.Provider value={{ appName, logoB64 }}>
      {children}
    </AppConfigContext.Provider>
  );
}
